import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]



export default /*@__PURE__*/_defineComponent({
  __name: 'DrinkIcon',
  props: {
  color: {
    type: String,
    default: '#C671C2'
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M8.28047 6.32227C7.3638 6.32227 6.45477 6.46445 5.55339 6.74883C4.652 7.0332 3.83464 7.4306 3.1013 7.94102L4.10964 16.6035H14.1013L15.1784 7.19727H14.0784C13.5093 7.19727 12.9889 7.15716 12.5172 7.07695C12.0455 6.99674 11.3971 6.84727 10.5721 6.62852C10.1902 6.52643 9.81207 6.44987 9.43776 6.39883C9.06345 6.34779 8.67769 6.32227 8.28047 6.32227ZM2.94089 6.47539C3.72005 6.00872 4.57179 5.65143 5.49609 5.40352C6.4204 5.1556 7.34852 5.02435 8.28047 5.00977C8.7388 5.00977 9.19332 5.03893 9.64401 5.09727C10.0947 5.1556 10.5263 5.2431 10.9388 5.35977C11.7199 5.56393 12.3175 5.70247 12.7315 5.77539C13.1455 5.84831 13.5868 5.88477 14.0555 5.88477H15.3388L15.8201 1.72852H2.39089L2.94089 6.47539ZM4.10964 17.916C3.75443 17.916 3.44505 17.8072 3.18151 17.5894C2.91797 17.3717 2.76901 17.0941 2.73464 16.7566L0.855469 0.416016H17.3555L15.4763 16.7566C15.4419 17.0941 15.293 17.3717 15.0294 17.5894C14.7659 17.8072 14.4565 17.916 14.1013 17.916H4.10964ZM8.28047 16.6035H14.0784H4.10964H8.28047Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ]))
}
}

})